import { render, staticRenderFns } from "./MsgContent.vue?vue&type=template&id=5445f9d6&"
import script from "./MsgContent.vue?vue&type=script&lang=js&"
export * from "./MsgContent.vue?vue&type=script&lang=js&"
import style0 from "./MsgContent.vue?vue&type=style&index=0&id=5445f9d6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports